import { useRouter } from 'next/router';
import React from 'react';

import { Avatar, Card, Space, Typography } from '@sravni/react-design-system';

import { preparePath } from '../../../../helpers/seo';
import { useMetadata } from '../../../../hooks/metadata';
import { useDictionaries } from '../../../../hooks/news';
import { ListContentLayout } from '../../../Layouts/ListContentLayout';
import { withListContainer, ListContainerProps } from '../../hoc/withListContainer';
import { ListContainer } from '../List';

import { NewsContainer } from './News';
import { PartnersListContainer } from './Partners';
import styles from './styles.module.scss';

const RubricListContainer: React.FC<ListContainerProps> = (props) => {
  const {
    query: { rubric },
    asPath,
  } = useRouter();
  const { rubrics } = useDictionaries();
  const metadata = useMetadata(preparePath(asPath));
  const currentRubric = rubrics.find((el) => el.alias === rubric);

  if (rubric === 'novosti-partnerov') {
    return <PartnersListContainer {...props} />;
  }
  if (rubric === 'novosti') {
    return <NewsContainer {...props} />;
  }

  return (
    <ListContainer
      {...props}
      heading={
        <ListContentLayout.Heading as={Card} className={styles.head}>
          <Space size={16}>
            <Avatar src={currentRubric.iconUrl} />
            <Typography.Heading level={2}>{currentRubric.name}</Typography.Heading>
          </Space>
          <Typography.Text size={14}>{metadata.description}</Typography.Text>
        </ListContentLayout.Heading>
      }
    />
  );
};

export const RubricList = withListContainer()(RubricListContainer);
